import { render } from "./AgeEiProfileComparisonBlock.vue?vue&type=template&id=76039965&scoped=true"
import script from "./AgeEiProfileComparisonBlock.vue?vue&type=script&lang=js"
export * from "./AgeEiProfileComparisonBlock.vue?vue&type=script&lang=js"

import "./AgeEiProfileComparisonBlock.vue?vue&type=style&index=0&id=76039965&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76039965"]])

export default __exports__